import React, {Component} from "react";
import {Button, Popconfirm} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

export default class TableOperation extends BaseComponent {

    render() {
        const {data, deleteTableItem, showConfigEdit} = this.props;
        return (
            <>
                {/*<Button type="link" onClick={() => this.showConfigEdit(data)}>查看</Button>*/}
                <span className="cm-link margin-right-15" onClick={() => showConfigEdit(data)}>修改</span>

                <Popconfirm
                    title={`确定删除配置项：${data.configName}`}
                    onConfirm={() => deleteTableItem(data)}
                    okText="确定"
                    cancelText="取消"
                >
                    <span className="cm-link">删除</span>
                </Popconfirm>
            </>
        );
    }
}
